
<p-inc-todo-card
    :item = "item"
>
    <template v-slot:comment>
        <div class="v-flex">
            <div class="card-subtitle status-line">
                {{ item.completeStatus }}
            </div>
            <v-spacer/>
            <div class="card-subtitle" :class="textColor()" v-if="item.begin && !future">
                {{ delay }} Tage
            </div>
        </div>
    </template>
</p-inc-todo-card>
